<template>
  <div class="content">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="RecordDetailsList">
      <el-button :disabled="multiple" class="gradeBtn" @click="exportGrades()">
        <i class="iconfont icon-daochu"></i><span>批量导出成绩</span></el-button
      >
      <p class="info">
        <span>姓名：{{ this.examOBj.RealName }}</span>
        <span>账号: {{ this.examOBj.userName }}</span>
      </p>
      <div class="gradeTable">
        <el-table
          ref="table"
          :data="getData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          @row-click="StepsListRowClick"
          @selection-change="handleSelectionChange"
          v-loading="isLoading"
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column label="序号" type="index" width="60" align="center">
            <template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template></el-table-column
          >
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="50"
            label-height="50"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="index == 0">{{ scope.row.ExamName }}</p>
              <p v-if="index == 1">{{ scope.row.TotalScore }}</p>
              <p v-if="index == 2">{{ scope.row.Score }}</p>
              <p v-if="index == 3">{{ scope.row.examTime }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button
                  @click.stop="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >查看答题详情</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="footBox">
        <div class="footPage">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pagesizesArr"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  studentDetail,
  studentExamTest,
  exportScoreExcel,
} from "@/services/examManager.js";
import eventBus from "@/utils/eventBus.js";

export default {
  props: ["changes"],
  data() {
    return {
      // 非多个禁用
      multiple: true,
      isLoading: true,
      // 表格数据
      getData: [],
      // checkcode: [],
      currentPage: 1, //  当前页数
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 100,
      // 考生信息
      examOBj: {
        userName: "",
        RealName: "",
        // 考生ID
        sudentUserID: 1,
        // 考试ID
        examID: 1,
        // 试卷名称
        ExamName: "",
      },
      // 答案详情参数
      answerDetailParam: {
        userID: "",
        RealName: "",
        SudentUserID: 0,
        ExamID: 0,
        ExamName: "",
      },
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      multipleSelection: [], // 当前页选中的数据
      changePageCoreRecordDataStats: true,
      idKey: "ExamID",
      formColumns: [
        {
          prop: "ExamName",
          label: "试卷名称",
        },
        {
          prop: "TotalScore",
          label: "总分",
        },
        {
          prop: "Score",
          label: "分数",
        },
        {
          prop: "examTime",
          label: "考试时间",
          width: "700px",
        },
      ],
    };
  },
  methods: {
    // 返回
    backBtn() {
      this.$parent.changes(0);
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 查看答题详情
    handleClick(row) {
      // console.log(row)
      this.studentExamTest(row);
    },

    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },

    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log("多选框选中数据...");
      this.multipleSelection = selection;
      if (this.changePageCoreRecordDataStats) {
        this.changePageCoreRecordData();
      }
      this.multiple = !this.multipleSelectionAll.length;
    },

    // 显示条数
    handleSizeChange(val) {
      this.changePageCoreRecordData();
      this.pageSize = val;
      this.testDetailList();
      console.log(`每页 ${val} 条`);
    },

    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.changePageCoreRecordData();
      this.currentPage = val;
      this.testDetailList();
      //this.handlePageData();
    },

    // 设置选中的方法
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.getData.length; i++) {
        if (selectAllIds.indexOf(this.getData[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.getData[i], true);
        }
      }
    },

    // 记忆选择核心方法
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      let selectAllIds = [];
      this.multipleSelectionAll.forEach((row) => {
        selectAllIds.push(row[idKey]);
      });
      let selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach((row) => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      let noSelectIds = [];
      // 得到当前页没有选中的id
      this.getData.forEach((row) => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach((id) => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] == id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
      console.log(this.multipleSelectionAll, "multipleSelectionAll");
      console.log(this.multipleSelection, "multipleSelection");
    },

    // 得到选中的所有数据
    getAllSelectionData() {
      // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
      this.changePageCoreRecordData();
      // console.log(this.multipleSelectionAll);
      return this.multipleSelectionAll;
    },

    // 得到选中的所有数据的id
    getAllSelectionExamIDs() {
      let data = this.getAllSelectionData();
      let ExamIDs = [];
      data.forEach((element) => {
        ExamIDs.push(element.ExamID);
      });
      return ExamIDs;
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    handlePageData() {
      this.getData = this.getData.map((item) => {
        let examTime = "";
        if (item.BeginTime != null && item.EndTime != null) {
          item.BeginTime1 = this.$moment(item.BeginTime).format(
            "YYYY/MM/DD HH:mm:ss"
          );
          item.EndTime1 = this.$moment(item.EndTime).format(
            "YYYY/MM/DD HH:mm:ss"
          );
          examTime = item.BeginTime1 + "-" + item.EndTime1;
        }
        item.examTime = examTime;
        return item;
      });
    },

    // 全部试题数据
    studentExamTest(row) {
      this.answerDetailParam = {
        ExamID: row.ExamID,
        ExamName: row.ExamName,
        SudentUserID: this.examOBj.sudentUserID,
        RealName: this.examOBj.RealName,
        userID: this.examOBj.userName,
      };
      this.changes(2);

      // const examTestPara = {};
      // this.UtilFun(examTestPara);
      // examTestPara.examID = row.ExamID;
      // examTestPara.sudentUserID = this.examOBj.sudentUserID;
      // examTestPara.pageIndex = this.currentPage - 1;
      // examTestPara.eachPageNum = this.pageSize;
      // console.log(examTestPara);
      // const { data } = await studentExamTest(examTestPara);
      // console.log(data);
      // if (data.Status === 200) {
      //   const arrData = data.Data.allTest || [];
      //   console.log(data.Data.allTest);
      //   // 给bus触发自定义事件，传递数据
      //   //eventBus.$emit("examDetailChange", arrData);
      // } else {
      //   this.$message.error(data.Msg);
      // }
    },

    // 获取父组件的数据进行初始化
    getParentData() {
      this.getData = this.$parent.$children[0].examDetailListArr;
      this.examOBj.userName = this.$parent.$children[0].rowdata.UserName;
      this.examOBj.RealName = this.$parent.$children[0].rowdata.RealName;
      this.examOBj.sudentUserID = this.$parent.$children[0].rowdata.UserID;
      this.handlePageData();
    },

    // 考试详情
    async testDetailList() {
      this.isLoading = true;
      console.log("this.$parent.$children[0]", this.$parent.$children[0]);
      const userID = this.$parent.$children[0].rowdata.UserID;
      const testDetailListPar = new Object();
      this.UtilFun(testDetailListPar);
      testDetailListPar.eachPageNum = this.pageSize;
      testDetailListPar.pageIndex = this.currentPage - 1;
      testDetailListPar.ksID = userID;
      console.log(testDetailListPar);
      const { data } = await studentDetail(testDetailListPar);
      console.log(data, "考试详情列表数据");
      if (data.Status === 200) {
        this.getData = data.Data.data;
        this.total = data.Data.count;
        this.handlePageData();
        setTimeout(() => {
          this.changePageCoreRecordDataStats = true;
          this.setSelectRow();
          this.isLoading = false;
        }, 100);
      } else {
        this.$message.error(data.Data);
      }
    },

    // 批量导出成绩
    exportGrades() {
      console.log("批量导出成绩...");
      let examIDArr = this.getAllSelectionExamIDs();
      if (examIDArr.length <= 0) {
        return;
      }
      // 请求参数
      const exportParam = new Object();
      this.UtilFun(exportParam);
      exportParam.sudentUserID = this.examOBj.sudentUserID;
      exportParam.examIDArr = `[${examIDArr}]`;
      console.log(exportParam, " <<============ 批量导出成绩请求数据");
      // 请求接口
      exportScoreExcel(exportParam)
        .then((res) => {
          if (res.data.type === "application/vnd.openxmlformats") {
            // 文件下载
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            });
            let link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute(
              "download",
              this.examOBj.RealName + "-成绩列表.xlsx"
            );
            link.click();
            link = null;
          } else {
            // 返回json
            this.$message.warning("导出文件类型错误或没有数据");
          }
        })
        .catch((err) => {
          this.$message.error("导出考生失败");
        });
    },
  },
  created() {},
  // 生命周期钩子
  activated() {
    this.testDetailList();
    this.currentPage = 1;
    this.getParentData();
    //console.log('???');
    // 给 bus 注册事件，并接收数据
    // eventBus.$on("listDataChange", (arrData, examOBj) => {
    //     this.getData = arrData;
    //     this.examOBj.userName = examOBj.UserName;
    //     this.examOBj.RealName = examOBj.RealName;
    //     // 考生ID
    //     this.examOBj.sudentUserID = examOBj.UserID
    //     console.log(this.examOBj, "8888");
    //     this.handlePageData()
    //   });
  },
  mounted() {},
  computed: {},
  beforeDestroy() {
    // 1.页面销毁时，取消监听
    eventBus.$off("listDataChange", this.handel);
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 100%;
  min-width: 1650px;
}
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

.RecordDetailsList {
  height: 849px;
  background: #ffffff;
  opacity: 1;
  border-radius: 10px;
  margin-top: 24px;
  padding: 24px;
  .gradeBtn {
    width: 142px;
    height: 40px;
    background: #64b5ff;
    opacity: 1;
    border-radius: 4px;
    span {
      width: 78px;
      height: 18px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 18px;
      color: #ffffff;
      opacity: 1;
    }
  }
}

.info {
  height: 52px;
  background: #eef7ff;
  opacity: 1;
  border-radius: 10px 10px 0px 0px;
  margin-top: 24px;
  line-height: 52px;
  span {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 16px;
    color: #333333;
    opacity: 1;
  }
  span:nth-child(1) {
    width: 80px;
    height: 22px;
    margin-left: 24px;
  }
  span:nth-child(2) {
    width: 154px;
    height: 22px;
    margin-left: 30px;
  }
}

// 表格
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #8fcbff;
  color: #333333;
  opacity: 1;
}

::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}

.gradeTable {
  .el-button {
    font-size: 16px;
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

// 分页
.footBox {
  position: relative;
  height: 110px;
}
.footPage {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  ::v-deep .el-pagination__jump {
    margin: 0px 10px 0px 0px !important;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
</style>
